import Reaction from 'entities/Reaction';
import Collection from 'lib/Collection';

export default class Reactions extends Collection<Reactions> {
  parse(response: any) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'reaction' implicitly has an 'any' type.
    return response.map((reaction) => Reaction.fromJSON(reaction));
  }
}
